import {createStore, withProps} from '@ngneat/elf';
import {withRequestsStatus} from '@ngneat/elf-requests';

import {SupplierDetails} from '@store/suppliers/details/supplier-details.model';

export const supplierDetailsStore = createStore(
  {name: 'supplier-details'},
  withProps<Partial<SupplierDetails>>({}),
  withRequestsStatus(),
);